import type { OverlayData } from "../../../types/navigation";
import isDevMode from "../../../util/isDevMode";
import { OverlayRect } from "../overlay-rect/OverlayRect.tsx";
import { RenderFragment } from "../../../fragments/RenderFragment.tsx";
import type { FragmentsKey } from "../../../fragments/fragmentRegistry.ts";
import type { ActionCallsType } from "../../../services/actionCalls.ts";
import "./overlays.css";
import { t } from "../../../i18n/translate.ts";

type ComponentProps = {
  id: string;
  elements?: OverlayData[];
  fragmentId?: string;
  onActionCall: ActionCallsType;
  changeScene: (sceneId: string) => void;
};

type Action = {
  name: string;
  args: any[];
};

export function Overlays({
  id,
  elements,
  fragmentId,
  onActionCall,
  changeScene,
}: ComponentProps) {
  const devMode = isDevMode();

  const handleActions = (actions: any | undefined) => {
    if (!actions) return;
    actions.forEach((action: Action) => {
      const actionFn = onActionCall[action.name as keyof ActionCallsType];
      return (actionFn as (...args: any[]) => void)(...action.args);
    });
  };

  const handleChange = (data: OverlayData) => {
    if (data.actions) handleActions(data.actions);
    if (data.link) changeScene(data.link);
  };

  const renderElements = (elements: OverlayData[]) =>
    elements.map((data: OverlayData, index: number) => (
      <OverlayRect
        key={index + data.label}
        {...data}
        label={t(data.label)}
        onClick={() => handleChange(data)}
      />
    ));

  // debugger

  return (
    <div
      id={id}
      className={`overlays-container ${devMode ? "overlays-devmode" : ""}`}
    >
      {elements && renderElements(elements)}
      {fragmentId && (
        <RenderFragment
          id={fragmentId as FragmentsKey}
          props={{ changeScene, onActionCall }}
        />
      )}
    </div>
  );
}
